class Header {
    constructor() {
        const header = document.querySelector('header');

        if (!header.classList.contains('-main')) return;

        this.init(header);
    }

    init(root) {
        this.root = root;
        this.main = document.querySelector('main');
        this.headerTop = this.root.querySelector('.header-top');
        this.headerMenu = this.root.querySelector('.header-menu');
        this.headerBottom = this.root.querySelector('.header-bottom');
        this.megamenuCheckboxes = this.root.querySelectorAll(
            "[type='checkbox'][name='megamenu_checkbox']"
        );

        this.scrollingDownClass = '-scrolling-down';
        this.scrollingTopClass = '-scrolling-top';
        this.lastScrollTop = 0;
        this.initMainPaddingTop = this.root.getBoundingClientRect().height;
        this.burgerButton = this.root.querySelector('.header-middle__burger');
        this.closeBurgerButtons = this.root.querySelectorAll(
            '.header-menu__close-burger'
        );
        this.backBurgerButtons = this.root.querySelectorAll(
            '.header-menu__back-wrapper'
        );

        this.handleMethods();
    }

    handleMethods() {
        this.handleMainInitPadding();
        window.addEventListener(
            'resize',
            this.handleMainInitPadding.bind(this)
        );
        window.addEventListener('scroll', this.handleHeaderScroll.bind(this), {
            passive: true,
        });
        this.handleBurger();
    }

    handleMainInitPadding() {
        if (
            !this.root.classList.contains(this.scrollingDownClass) ||
            !this.root.classList.contains(this.scrollingTopClass)
        ) {
            this.root.style.removeProperty('height');
            this.initMainPaddingTop = this.root.getBoundingClientRect().height;
            this.root.style.height = `${this.initMainPaddingTop}px`;
            this.main.style.paddingTop = `${this.initMainPaddingTop}px`;
            window.scrollBy(0, 1);
        }
    }

    handleHeaderScroll() {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        const minimumScroll = this.headerTop.clientHeight;
        const headerMenuHeight =
            window.innerWidth < 991.98 ? 0 : this.headerMenu.clientHeight;
        const headerBottomHeight = this.headerBottom?.clientHeight || 0;

        if (scrollTop > this.lastScrollTop && scrollTop > minimumScroll) {
            if (this.megamenuCheckboxes && window.innerWidth > 991.98) {
                this.megamenuCheckboxes.forEach(item => (item.checked = false));
                this.root.classList.remove('-no-overflow');
            }
            this.root.classList.add(this.scrollingDownClass);
            this.root.style.top = `-${minimumScroll}px`;
            this.root.style.height = `${
                this.initMainPaddingTop - headerMenuHeight - headerBottomHeight
            }px`;
            this.main.style.paddingTop = `${
                this.initMainPaddingTop -
                minimumScroll -
                headerMenuHeight -
                headerBottomHeight
            }px`;
        } else if (
            scrollTop < this.lastScrollTop &&
            scrollTop > minimumScroll
        ) {
            this.root.classList.add(this.scrollingTopClass);
            this.root.classList.remove(this.scrollingDownClass);
            this.root.style.top = `0px`;
        } else {
            this.root.classList.remove(this.scrollingTopClass);
            this.root.classList.remove(this.scrollingDownClass);
            this.root.style.removeProperty('top');
            this.main.style.paddingTop = `${this.initMainPaddingTop}px`;
            this.root.style.height = `${this.initMainPaddingTop}px`;
        }

        this.lastScrollTop = scrollTop;
    }

    handleBurger() {
        if (this.burgerButton) {
            this.burgerButton.addEventListener('click', () => {
                this.headerMenu.classList.add('-active');
                document.body.classList.add('no-scroll');
                this.megamenuCheckboxes.forEach(item => (item.checked = false));
            });
        }
        if (this.closeBurgerButtons.length) {
            this.closeBurgerButtons.forEach(element => {
                element.addEventListener('click', () => {
                    this.headerMenu.classList.remove('-active');
                    document.body.classList.remove('no-scroll');
                });
            });
        }
        if (this.backBurgerButtons.length) {
            this.backBurgerButtons.forEach(element => {
                element.addEventListener('click', () => {
                    this.megamenuCheckboxes.forEach(
                        item => (item.checked = false)
                    );
                });
            });
        }
    }
}

new Header();
